import { ReactNode, forwardRef, ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "w-6 h-6 shrink-0 rounded flex items-center justify-center bg-transparent hover:bg-[rgba(234,236,240,1)] transition-colors",
          className
        )}
        type="button"
        tabIndex={-1}
        {...props}
      >
        {icon}
        <span className="sr-only">{props["aria-label"]}</span>
      </button>
    );
  }
);

IconButton.displayName = "IconButton";
